'use strict'
import { app } from './old/app'
import { common } from './old/common'
import { ScrollAnimation } from './lib/ScrollAnimation'
import { Svg } from './lib/Svg'
import { TelGrant } from './lib/TelGrant'
import { Smooth } from './lib/Smooth'
import { AutowidthSliders } from './lib/AutowidthSliders'
import { WorldSliderControls } from './lib/world/SliderControls'
import { WorldModals } from './lib/world/Modals'
import { CommonAccordions } from './lib/CommonAccordions'
import { LazyYoutubes } from './lib/world/LazyYoutubes'
import { HeaderCta } from './lib/HeaderCta'
import { KvAnimation } from './lib/KvAnimation'
import { Accordion } from './lib/Accordion'
common()
app()

new Svg()
new ScrollAnimation()
new Smooth()
new TelGrant()
new LazyYoutubes()
new WorldModals()
new HeaderCta()
const autowidthSliders = new AutowidthSliders()
new WorldSliderControls(autowidthSliders.sliders)
new CommonAccordions()
new KvAnimation()
new Accordion()
